// utils/globalUtils.js
const default_gd_domain = "life.app.sccncd.com";
const default_ioetop_domain = "unit.ioe.top";
let default_auth_domain = default_gd_domain;

import Cookies from 'js-cookie'

// 工具函数集合
export const globalUtils = {
	/**
	  * 获取当前访问域名
	  * @param {boolean} includeProtocol - 是否包含协议（http/https）
	  * @param {boolean} includePort - 是否包含端口号
	  * @param {boolean} includePath - 是否包含路径
	  * @returns {string} 域名
	  */
	getCurrentDomain(includeProtocol = false, includePort = false, includePath = false) {
		try {
			const { protocol, hostname, port, pathname } = window.location;

			let domain = hostname;

			// 包含协议
			if (includeProtocol) {
				domain = `${protocol}//${domain}`;
			}

			// 包含端口（非默认端口时）
			if (includePort && port && port !== '80' && port !== '443') {
				domain = includeProtocol ? `${domain}:${port}` : `${domain}:${port}`;
			}

			// 包含路径
			if (includePath) {
				domain = `${domain}${pathname}`;
			}

			return domain
		} catch (error) {
			console.error('获取域名失败:', error);
			return '';
		}
	},

	/*
	  * 获取当前访问域名
	  * @param {boolean} includeProtocol - 是否包含协议（http/https）
	  * @param {boolean} includePort - 是否包含端口号
	  * @param {boolean} includePath - 是否包含路径
	  * @param {int} type - 0 默认端口，1 访问本地资源，2 认证使用，3 IOETOP服务器
	  * @returns {string} 域名
	  */
	getBaseUrl(includeProtocol = false, includePort = false, includePath = false, includeType = 0) {
		try {
			const { protocol, hostname, port, pathname } = window.location;

			let domain = hostname;

			// 包含协议
			if (includeProtocol) {
				domain = `${protocol}//${domain}`;
			}

			if(includeType==0)
			{
				// 包含端口（非默认端口时）
				if (includePort && port && port !== '80' && port !== '443') {
					domain = `${domain}:${port}`;
				}
				else
				{
					domain = `${domain}`;
				}
			}
			else if(includeType==1)
			{
				// 正式访问，只使用默认端口
			}
			else if(includeType==2)
			{
				//domain = "https://life.app.sccncd.com/";
				// 包含协议
				if (includeProtocol) {
					domain = `${protocol}//${default_gd_domain}`;
				}
				else {
					domain = `${default_gd_domain}`;
				}
			}
			else if(includeType==3)
			{
				//domain = "https://unit.ioe.top/";
				// 包含协议
				if (includeProtocol) {
					domain = `${protocol}//${default_ioetop_domain}`;
				}
				else {
					domain = `${default_ioetop_domain}`;
				}
			}

			// 包含路径
			if (includePath) {
				domain = `${domain}${pathname}`;
			}

			return domain
		} catch (error) {
			console.error('获取域名失败:', error);
			return '';
		}
	},

	/**
	  * 获取完整当前URL
	  * @returns {string} 完整URL
	  */
	getCurrentFullUrl() {
		return window.location.href;
	},

	/**
	  * 获取基础域名（不带www前缀）
	  * @returns {string} 基础域名
	  */
	getBaseDomain() {
		try {
			const hostname = window.location.hostname;
			// 去除www前缀
			return hostname.replace(/^www\./, '');
		} catch (error) {
			console.error('获取基础域名失败:', error);
			return '';
		}
	},

	/**
	  * 获取当前访问的协议
	  * @returns {string} 协议（http: 或 https:）
	  */
	getProtocol() {
		return window.location.protocol;
	},

	/**
	  * 获取当前访问的端口
	  * @returns {string} 端口号
	  */
	getPort() {
		return window.location.port;
	},

	/**
	  * 获取当前访问的路径
	  * @returns {string} 路径
	  */
	getPath() {
		return window.location.pathname;
	},
	
	/**
	  * 判断是否在移动端访问
	  * @returns {boolean} 是否移动端
	  */
	isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	},

	/**
	  * 判断是否在微信内访问
	  * @returns {boolean} 是否微信环境
	  */
	isWechat() {
		return /micromessenger/i.test(navigator.userAgent);
	},

	/**
	  * 检测设备
	  * @returns {int} <0 移动设备 >0 屏幕宽度
	  */
	detectDevice() {
		// 如果正在模拟设备，则跳过实际检测
		const userAgent = navigator.userAgent;
		const byUserAgent = this.isMobile(); // /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
		const byWidth = window.innerWidth < 768;
		
		// 优先使用用户代理检测，同时考虑屏幕宽度
		if (byUserAgent && byWidth) {
			return -1;
			//this.isMobile = true;
			//this.detectionMethod = '用户代理和屏幕宽度均指示为移动设备';
		} else if (byUserAgent) {
			return -2;
			//this.isMobile = true;
			//this.detectionMethod = '用户代理指示为移动设备';
		} else if (byWidth) {
			return -3;
			//this.isMobile = true;
			//this.detectionMethod = '屏幕宽度指示为移动设备';
		} else {
			return window.innerWidth;
			//this.isMobile = false;
			//this.detectionMethod = '用户代理和屏幕宽度均指示为电脑/平板';
		}
		
		//this.screenWidth = window.innerWidth;
	},

	/**
	  * 获取当前用户信息
	  * @returns {ojbect/array} 对象
	  */
	getCurInfo() {
		// 读取本次登陆信息
		const curUserLogin = Cookies.get('curUserLogin');
		// 是否正确读取
		if (curUserLogin) {
			try {
				// 解析用户信息
				const u = JSON.parse(curUserLogin);
				return u;
			} catch (e) {
				// 解析用户信息失败
				console.error('解析用户信息失败', e);
				return false;
			}
		}
		// 验证失败
		return false;
	},
	
	/**
	  * 验证登陆状态
	  * @returns {ojbect/array} 对象
	  */
	fun_is_online() {
		// 读取本次登陆信息
		const curUserLogin = Cookies.get('curUserLogin');
		if (curUserLogin) {
			try {
				// 解析用户信息
				const u = JSON.parse(curUserLogin);
				// 发送校验西悉尼
				return {
					username: u.username,
					at: u.at
				};
			} catch (e) {
				// 解析用户信息失败
				console.error('解析用户信息失败', e);
				return false;
			}
		}
		// 验证失败
		return false;
	},

	/**
	  * 是否为数组
	  * @param {obj} obj - 对象
	  * @returns {bool} 是否
	  this.$utils.isArray
	  */
	isArray(obj) {
		// 如果浏览器支持原生 Array.isArray，直接使用
		if (typeof Array.isArray === 'function') {
			return Array.isArray(obj);
		}

		// 否则使用 Object.prototype.toString 进行判断
		return Object.prototype.toString.call(obj) === '[object Array]';
	},

	/**
	  * 格式化日期
	  * @param {Date|string} date - 日期
	  * @param {string} format - 格式类型
	  * @returns {string} 日期
	  */
	formatDate(date, format = 'YYYY-MM-DD') {
		if (!date) return '';
		const d = new Date(date);

		switch (format) {
			case 'YYYY-MM-DD':
				return d.toISOString().split('T')[0];
			case 'YYYY-MM-DD HH:mm:ss':
				return d.toLocaleString('zh-CN');
			case 'YYYY年MM月DD日':
				return d.toLocaleDateString('zh-CN');
			default:
				return d.toLocaleDateString('zh-CN');
		}
	},

	/**
	  * 深拷贝对象
	  * @param {obj} obj - 对象
	  * @returns {ojbect/array} 对象
	  */
	deepClone(obj) {
		return JSON.parse(JSON.stringify(obj));
	},

	/**
	  * 生成随机ID
	  * @returns {string} 随机ID
	  */
	generateId() {
		return Math.random().toString(36).substr(2, 9);
	},

	/**
	  * 获取URL参数
	  * @param {string} name - 参数名
	  * @returns {string} 参数值
	  */
	getUrlParam(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	},

	/**
	  * 下载文件
	  */
	downloadFile(url, filename) {
		const link = document.createElement('a');
		link.href = url;
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},

	/**
	  * 与 PHP urlencode 功能相同的 URL 编码函数
	  * @param {string} str - 要编码的字符串
	  * @returns {string} 编码后的字符串
	  */
	url_encode(str) {
		if (typeof str !== 'string') {
			return '';
		}
		
		return encodeURIComponent(str)
			.replace(/%20/g, '+')
			.replace(/!/g, '%21')
			.replace(/'/g, '%27')
			.replace(/\(/g, '%28')
			.replace(/\)/g, '%29')
			.replace(/\*/g, '%2A')
			.replace(/~/g, '%7E');
	},

	/**
	  * 与 PHP urldecode 功能相同的 URL 解码函数
	  * @param {string} str - 要解码的字符串
	  * @returns {string} 解码后的字符串
	  */
	url_decode(str) {
		if (typeof str !== 'string') {
			return '';
		}
		
		// 先将 + 号替换为 %20，然后使用 decodeURIComponent 解码
		return decodeURIComponent(str.replace(/\+/g, '%20'));
	},

}

// 常量定义
export const constants = {
	USER_ROLES: {
		ADMIN: 'admin',
		VENDOR: 'vendor',
		STAFF: 'staff',
		PARTNER: 'partner'
	},
	STORAGE_KEYS: {
		USER_LOGIN: 'curUserLogin',
		USER_INFO: 'userInfo',
		THEME: 'appTheme'
	}
}

// 默认配置
export const defaultConfig = {
	appName: '运营中心 v1.21',
	uploadMaxSize: 10 * 1024 * 1024, // 10MB
	timeout: 30000
}